import { React } from "react";
import CardElement from "../../../Components/UiComponents/CardElement";

export default function PortfolioCard(props) {
	return (
		<CardElement
			isProgressBar={props.progressBar}
			title={props.title}
			progressStatus={props.progressStatus}
			progressPercentage={props.progressPercentage}
			costValue={props.costValue}
			sectionPermissions={props.sectionPermissions}
			pendingResponsibility={props.pendingResponsibility}
		></CardElement>
	);
}
